import React, { Component } from 'react';
import { Provider, observer } from 'mobx-react';
import { history } from "../../../history_mobx";
import myStore from "../../../stores/store";
import { Router } from "react-router";
import LastComboCommentsWithStore from "./LastComboCommentsWithStore";



class LastComboCommentsOnly extends Component {
  render() {
    return (
      <Provider {...myStore.getStores()}>
        <Router history={history}>
          <div></div>
          <LastComboCommentsWithStore {...this.props} standalone={true} />
        </Router>
      </Provider>
    );
  }
}

export default observer(LastComboCommentsOnly);
